import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';

import { BaseAPI } from '../utils/Api';
import { getItem, removeAll } from '../utils/Helper';

export const GetPaymentList = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  return useQuery(
    ['get-payment-list'],
    () =>
      BaseAPI.get('/payment/billing', {
        headers: { Authorization: `Bearer ${getItem(localStorage, 'at')}` },
      }),
    {
      onError: (error) => {
        if (!error?.response?.data?.message && !error?.message) {
          enqueueSnackbar('Something went wrong!', { variant: 'error' });
        } else if (error?.response?.data?.message === 'Session Expired') {
          removeAll(localStorage);
          navigate('/signin');
        } else {
          enqueueSnackbar(error?.response?.data?.message || error?.message, { variant: 'error' });
        }
      },
      select: (data) => data?.data?.data,
    }
  );
};

export const GetPackages = (useId) => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  return useQuery(
    ['get-packages'],
    () =>
      BaseAPI.get(`/payment/packages?user_id=${useId}`, {
        headers: { Authorization: `Bearer ${getItem(localStorage, 'at')}` },
      }),
    {
      onError: (error) => {
        if (!error?.response?.data?.message && !error?.message) {
          enqueueSnackbar('Something went wrong!', { variant: 'error' });
        } else if (error?.response?.data?.message === 'Session Expired') {
          removeAll(localStorage);
          navigate('/signin');
        } else {
          enqueueSnackbar(error?.response?.data?.message || error?.message, { variant: 'error' });
        }
      },
      select: (data) => data?.data?.data,
    }
  );
};

export const VerifyPayment = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const client = useQueryClient();

  return useMutation(
    (data) =>
      BaseAPI.post('payment/verify-request', data, {
        headers: { Authorization: `Bearer ${getItem(localStorage, 'at')}` },
      }),
    {
      onSuccess: () => {
        client.invalidateQueries(['get-payment-list']);
        client.invalidateQueries(['get-access']);
        client.invalidateQueries(['get-packages']);
      },
      onError: (error) => {
        if (!error?.response?.data?.message && !error?.message) {
          enqueueSnackbar('Something went wrong!', { variant: 'error' });
        } else if (error?.response?.data?.message === 'Session Expired') {
          removeAll(localStorage);
          navigate('/signin');
        } else {
          enqueueSnackbar(error?.response?.data?.message || error?.message, { variant: 'error' });
        }
      },
    }
  );
};

export const VerifyTransaction = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const client = useQueryClient();

  return useMutation(
    (data) =>
      BaseAPI.post('payment/verify-transaction', data, {
        headers: { Authorization: `Bearer ${getItem(localStorage, 'at')}` },
      }),
    {
      onSuccess: () => {
        client.invalidateQueries(['get-access']);
      },
      onError: (error) => {
        if (!error?.response?.data?.message && !error?.message) {
          enqueueSnackbar('Something went wrong!', { variant: 'error' });
        } else if (error?.response?.data?.message === 'Session Expired') {
          removeAll(localStorage);
          navigate('/signin');
        } else {
          enqueueSnackbar(error?.response?.data?.message || error?.message, { variant: 'error' });
        }
      },
    }
  );
};

export const ChangeCard = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  return useMutation(
    (data) =>
      BaseAPI.post('payment/generate-link', data, {
        headers: { Authorization: `Bearer ${getItem(localStorage, 'at')}` },
      }),
    {
      onError: (error) => {
        if (!error?.response?.data?.message && !error?.message) {
          enqueueSnackbar('Something went wrong!', { variant: 'error' });
        } else if (error?.response?.data?.message === 'Session Expired') {
          removeAll(localStorage);
          navigate('/signin');
        } else {
          enqueueSnackbar(error?.response?.data?.message || error?.message, { variant: 'error' });
        }
      },
    }
  );
};

export const DownloadInvoice = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  return useMutation(
    (data) =>
      BaseAPI.post('payment/invoice-link', data, {
        headers: { Authorization: `Bearer ${getItem(localStorage, 'at')}` },
      }),
    {
      onError: (error) => {
        if (!error?.response?.data?.message && !error?.message) {
          enqueueSnackbar('Something went wrong!', { variant: 'error' });
        } else if (error?.response?.data?.message === 'Session Expired') {
          removeAll(localStorage);
          navigate('/signin');
        } else {
          enqueueSnackbar(error?.response?.data?.message || error?.message, { variant: 'error' });
        }
      },
    }
  );
};

export const bKashConfirmationRequest = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  return useMutation(
    (data) =>
      BaseAPI.post('payment/bkash-request', data, {
        headers: { Authorization: `Bearer ${getItem(localStorage, 'at')}` },
      }),
    {
      onError: (error) => {
        if (!error?.response?.data?.message && !error?.message) {
          enqueueSnackbar('Something went wrong!', { variant: 'error' });
        } else if (error?.response?.data?.message === 'Session Expired') {
          removeAll(localStorage);
          navigate('/signin');
        } else {
          enqueueSnackbar(error?.response?.data?.message || error?.message, { variant: 'error' });
        }
      },
    }
  );
};

export const GetBkashTransactions = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  return useQuery(
    ['get-bkash-transactions'],
    () =>
      BaseAPI.get('/payment/bkash-transactions', {
        headers: { Authorization: `Bearer ${getItem(localStorage, 'at')}` },
      }),
    {
      onError: (error) => {
        if (!error?.response?.data?.message && !error?.message) {
          enqueueSnackbar('Something went wrong!', { variant: 'error' });
        } else if (error?.response?.data?.message === 'Session Expired') {
          removeAll(localStorage);
          navigate('/signin');
        } else {
          enqueueSnackbar(error?.response?.data?.message || error?.message, { variant: 'error' });
        }
      },
      select: (data) => data?.data?.data,
    }
  );
};

export const GetAccess = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  return useQuery(
    ['get-access'],
    () =>
      BaseAPI.get('/payment/access', {
        headers: { Authorization: `Bearer ${getItem(localStorage, 'at')}` },
      }),
    {
      onError: (error) => {
        if (!error?.response?.data?.message && !error?.message) {
          enqueueSnackbar('Something went wrong!', { variant: 'error' });
        } else if (error?.response?.data?.message === 'Session Expired') {
          removeAll(localStorage);
          navigate('/signin');
        } else {
          enqueueSnackbar(error?.response?.data?.message || error?.message, { variant: 'error' });
        }
      },
      select: (data) => data?.data?.data,
    }
  );
};
